import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Image, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { translate, t } from "react-multi-lang";
import "./EventPageIndex.css";
import {
    fetchMyEventBookingsStart
} from "../../store/actions/EventAction";
import moment from "moment";
import NoDataFound from "../NoDataFound/NoDataFound"

function getStatusBadge(status) {
    switch (status) {
        case "Upcoming":
            return <Badge pill variant="success" className="badge-category">{status}</Badge>;
        case "Passed":
            return <Badge pill variant="danger" className="badge-category">{status}</Badge>;
        case "Ongoing":
            return <Badge pill variant="info" className="badge-category">{status}</Badge>;
        default:
            return null;
    }
}

function formatSmartTime(minutes) {

    if (minutes >= 60) {
        const hrs = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return mins > 0 ? `${hrs} hours ${mins} minutes` : `${hrs} hours`;
        // Example: 2h 30m or 2h
    } else {
        return `${minutes} minutes`;
        // Example: 45m
    }
}


function MyBookings(props) {
    const { data: bookings, loading, error } = useSelector(
        (state) => state.event.myEventBookings
    );

    // fetch my bookings
    useEffect(() => {
        props.dispatch(fetchMyEventBookingsStart({ email: localStorage.getItem("email") }));
    }, []);

    if (loading) return <p>Loading bookings...</p>;
    if (error) return <p className="text-danger">Error: {error}</p>;

    return (
        <div className="notification-page">
            <Container>
                <div className="profile-post-area">
                    <div className="bookmarkes-list bookmarks-right-side resp-sapce-center">
                        <div className="pull-left">
                            <Link className="bookmarkes-list notify-title" to={`/home`}>
                                <Image
                                    src="/assets/images/icons/back.svg"
                                    className="svg-clone mr-2"
                                />

                                My Bookings
                            </Link>
                        </div>
                    </div>
                </div>
                {bookings && bookings.length > 0 ? bookings.map((booking) => (
                    <Row key={booking.id || Math.random()}>
                        <Card className="shadow-sm d-flex flex-row flex-wrap w-100 mb-4">
                            <Col xs={12} sm={12} md={6} lg={3} className="card-img-wrapper h-auto">

                                {/* Event Image */}
                                <Image
                                    src={booking.event?.event_image || "/assets/images/placeholder.png"}
                                    alt={booking.event?.title || "Event Image"}
                                    className="card-img-top"
                                />

                            </Col>
                            <Col xs={12} sm={12} md={6} lg={9} className="mb-4">

                                {/* Details */}
                                <Card.Body className="d-flex flex-column justify-content-between flex-grow-1">
                                    <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                                        <Card.Title className="event-title">{booking.event?.title || "No Title"}</Card.Title>
                                        {booking.event?.status && getStatusBadge(booking.event.status)}
                                    </div>

                                    <Card.Text>
                                        {booking.event?.start_datetime && (
                                            <p>
                                                <i className="fas fa-lg fa-calendar-alt mr-4" />
                                                <span className="meta-text">{moment(booking.event.start_datetime).format("ddd, MMM DD YYYY")} | </span>

                                                <span className="meta-text">
                                                    {moment(booking.event.start_datetime).format("h:mm A")}</span>
                                            </p>
                                        )}
                                        {booking.event?.duration_minutes !== undefined && booking.event?.duration_minutes !== null && (
                                            <p>
                                                <i className="fas fa-hourglass-half mr-4 fa-lg" />  <span className="meta-text">{formatSmartTime(booking.event.duration_minutes)}</span>
                                            </p>
                                        )}
                                        {booking.event?.venue && (
                                            <p className="d-flex">
                                                <i className="fas fa-lg fa-map-marker-alt mr-4 mt-2" />
                                                <span className="meta-text ml-1">{booking.event.venue}</span>
                                            </p>
                                        )}
                                        <p className="d-flex">
                                            <i className="fas fa-lg fa-users mr-3 mt-2 ml-0" />
                                            <span className="meta-text">{booking.number_of_persons} {booking.number_of_persons > 1 ? "Persons" : "Person"}</span>
                                        </p>
                                        <p className="d-flex">
                                            <i className="fas fa-lg fa-money-bill-alt mr-3 mt-2" />
                                            {booking.total_price == 0 ? (<span className="meta-text">
                                                <b className="badge badge-warning p-2 fw-bolder text-white">Complimentary</b></span>) : (<span className="meta-text">
                                                    <b className="badge badge-info p-2 fw-bolder">Paid {"$" + booking.total_price}</b> via {booking.card?.card_type} {booking.card?.last_four}</span>)}

                                        </p>
                                    </Card.Text>

                                    {/* QR Codes */}
                                    <div className="d-flex flex-wrap mt-2 qr_mobile_div">
                                        {booking.bookings?.map((qr, index) => (
                                            <Image
                                                key={index}
                                                src={qr.qr_code_url}
                                                rounded
                                                style={{
                                                    width: "200px",
                                                    height: "200px",
                                                    objectFit: "cover",
                                                    marginRight: "5px",
                                                    marginBottom: "5px",
                                                }}
                                            />
                                        ))}
                                    </div>

                                    {/* Optional Button */}
                                    {booking.status === "Upcoming" && (
                                        <Button variant="primary" size="sm" className="mt-2">
                                            Pay Now
                                        </Button>
                                    )}
                                </Card.Body>
                            </Col>
                        </Card>
                    </Row>
                )) : (
                    <NoDataFound></NoDataFound>
                )}
            </Container>
        </div>
    );
}

const mapStateToPros = (state) => ({
    myEventBookings: state.event.myEventBookings,
});

function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(translate(MyBookings));

